<app-breadcrumb [expandBreadcrumb]="expandBreadcrumb"></app-breadcrumb>
<div class="gridnav-list-container">
  <!--  <mat-grid-list [cols]="constants.NAV_ITEMS.length" rowHeight="2:1"-->
  <!--                 cols="2">-->
  <!--    <mat-grid-tile *ngFor="let navItem of constants.NAV_ITEMS" colspan="4" rowspan="1">-->
  <!--      <mat-grid-tile-header>{{navItem.displayName}}</mat-grid-tile-header>-->
  <!--      {{navItem.children}}-->
  <!--      &lt;!&ndash;      <mat-grid-tile-footer>{{navItem.displayName}}</mat-grid-tile-footer>&ndash;&gt;-->
  <!--    </mat-grid-tile>-->
  <!--  </mat-grid-list>-->

  <mat-card class="nav-card-item" *ngFor="let navItem of constants.NAV_ITEMS">
    <mat-card-subtitle>Wetter</mat-card-subtitle>
    <mat-card-title routerLink="{{navItem.route}}">{{navItem.displayName}}</mat-card-title>
    <mat-card-content>
      <button *ngFor="let child of navItem.children" routerLink="{{child.route}}">{{child.displayName}}</button>
    </mat-card-content>
  </mat-card>
</div>
